export default {
    brokers: { showRemoved: false, list: [], new: {}, edit: {}, tableList: {} }
};
